import events from "../calendar/events.json";

export default interface IEvent {
	date: Date,
	title: string,
	isHoliday: boolean,
}

export function getEventsOf(origin: Date) {
	const date = new Date(origin.getTime());
	const hijriDate = new Date(origin.getTime());
	// let hijriDate = day.date;
	hijriDate.setDate(hijriDate.getDate() - 1);
  //@ts-ignore
  const d = hijriDate.toLocaleDateString('ar-SA', { month: '2-digit', day: '2-digit' }).split('/').map(a => a.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
  // @ts-ignore
  const ghamari: IEvent[] = events.ghamari[`${d[1]}/${d[0]}`.replace(/[^\u0000-\u007E]/g, "")]?.map((event: any) => { return { ...event, date: date } }) ?? [];
  // @ts-ignore
  const jalali: IEvent[] = events.jalali[date.toLocaleDateString('fa-IR', { month: '2-digit', day: '2-digit' }).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))]?.map((event: any) => { return { ...event, date: date } }) ?? [];
  // @ts-ignore
  const gregorian: IEvent[] = events.gregorian[date.toLocaleDateString('en-SA', { month: '2-digit', day: '2-digit' })]?.map((event: any) => { return { ...event, date: date } }) ?? [];
  return [...ghamari, ...jalali, ...gregorian];
}
